import { httpRequest } from "../../http";

import { Employee } from "@models/employee.model";
import { EmployeeSerializer } from "@models/serializers/employeeSerializer";

export class CommandCreateEmployee {
  async run(personId: number, organizationId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/employees/`;
    const body = {
      person: {
        id: personId,
      },
      organization: {
        id: organizationId,
      },
    };
    try {
      const response = await httpRequest<any>(url, { method: "POST", body });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Employee {
    const serializer = new EmployeeSerializer();
    return serializer.deserialize(data);
  }
}
